// extracted by css-extract-rspack-plugin
export default {"sidebar":"PuiX4","wrap":"mcf6f","section":"qZlxh","titleLink":"T7OC3"};